<template>
  <div class="product-card">
      <a v-if="this.business && this.item.IsAFGChioce"><img class="afg-choice-img" src="../assets/img/afg_choice_tag.png" /></a>
    <div class="product_box">
      <div class="ProImg" @click="goToProductDetail(item)">
        <a v-if="this.img==='' && !this.business"><img src="../assets/img/coming.png" alt=""></img></a>
        <a v-else>
          <v-lazy-image
            :src="this.img"
            alt=""
            :intersection-options="{ rootMargin: '1000px' }"
          />
          </a>
      </div>
      <div class="Pro-Details">
        <p v-if="this.business && $i18n.locale=='en'" class="ProTitle"><a :href="this.link">{{this.b2bCase.Name}}</a></p>
        <p v-else-if="this.business && $i18n.locale=='ch'" class="ProTitle"><a :href="this.link">{{this.b2bCase.Description}}</a></p>
        <p v-else class="ProTitle"><a :href="this.link">{{this.name}}</a></p>
        <p class="ProTitle" v-if="item.IsAlcohol"><a class="alcohol">Alcohol: must be over 21 years old, CA ONLY</a></p>
        <div v-if="!this.business" class="price-bot">
          <div class="price-merge">
            <div :class="['price__regular', this.isPromotion ? 'hot' : '']">
              <span>${{item.Price ? item.Price.toFixed(2) : ''}}</span>
            </div>
            <div class="price_original" v-show="isPromotion"><span>${{item.OriginalPrice ? item.OriginalPrice.toFixed(2) : ''}}</span></div>
          </div>
          <button v-if="isOutOfStock(item)" class="ajax_addto_cart_btn">{{ $t('outOfStock') }}</button>
          <div v-else-if="found && windowWidth >= 450" class="qty_and_cart">
          <!--qty-->
          <div class="mobileqty">
            <div class="qty_input">
              <button
                @click="incrementAddToCart(item, false, $event)"
                class="decrement"
                :style="'outline: none'">-</button>
              <span class="cart-quantity">{{this.num}}</span>
              <button
                @click="throttleAddToCart(item, $event)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 35px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              +
              </button>
            </div>
          </div>
          <div v-if="!item.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
            <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
            <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
              <span id="AddToCartText-product-template">Sold out</span>
            </button>
          </div>
        </div>
        <div v-else class="qty_and_cart">
          <div class="mobileqty">
            <div class="qty_input">
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              <button
                v-if="this.num === 0"
                @click="throttleAddToCart(item, $event)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 35px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >+</button>
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              <button
                v-else
                @click="throttleAddToCart(item, $event)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 24px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >{{this.num}}</button>
            </div>
          </div>
          <div v-if="!item.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
            <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
            <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
              <span id="AddToCartText-product-template">Sold out</span>
            </button>
          </div>
          </div>
        </div>
        <div v-else-if="this.business" class="price-bot">
          <div class="price-merge">
            <div :class="['price__regular']" >
              <div :class="['b2b-case', b2bCase && b2bCase.IsPromotion ? 'hot' : '']">${{b2bCase.Price ? b2bCase.Price.toFixed(2) : ''}} {{this.container === "master" ? "mcs" : "ics"}}</div>
              <div :class="['medium-font', b2bCase && b2bCase.IsPromotion ? 'hot' : '']">(${{b2bCost}} ea)</div>
            </div>
            <div class="price_original" v-show="b2bCase.IsPromotion"><span class="small-font">${{b2bCase.OriginalPrice ? b2bCase.OriginalPrice.toFixed(2) : ''}}</span></div>
          </div>
          <button v-if="isOutOfStockBusiness(b2bCase)" class="ajax_addto_cart_btn">{{ $t('outOfStock') }}</button>
          <div v-else-if="found && windowWidth >= 550" class="qty_and_cart">
          <!--qty-->
          <div class="mobileqty">
            <div class="qty_input">
              <button
                @click="incrementAddToCart(b2bCase, false, $event)"
                class="decrement"
                :style="'outline: none'">-</button>
              <span class="cart-quantity">{{this.num}}</span>
              <button
                @click="b2bAddToCart(b2bCase)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 35px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              +
              </button>
            </div>
          </div>
        </div>
        <div v-else class="qty_and_cart">
          <div class="mobileqty">
            <div class="qty_input">
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              <button
                v-if="this.num === 0"
                @click="b2bAddToCart(b2bCase)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 35px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >+</button>
              <!-- The styling here must be kept inline or else the traveling animation will default to original styling -->
              <button
                v-else
                @click="b2bAddToCart(b2bCase)"
                class="increment"
                :style="'borderRadius: 15px; fontSize: 24px; width: 30px; outline: none; height: 30px; boxShadow: none; fontFamily: Raleway; backgroundColor: #EC4E00; color: white: marginTop: auto; color: white; box-shadow: 1px 3px 0 #432B0D; padding: 0; margin-top: auto; line-height: 9px;'"
              >{{this.num}}</button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { flyToElement } from "../store/modules/cart.js";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
export default {
  name: 'productCard',
  props: [
    'img',
    'link',
    'name',
    'isPromotion',
    'price',
    'item',
    'quantity',
    'showPrice',
  ],
  data() {
    return {
      list: [],
      found: false,
      num: 0,
      localCount: 0,
      masterInner: '',
      b2bCase: {},
      container: '',
      outOfStockBusiness: false,
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('cart', ['updateProductCount']),
    ...mapActions('cart',['addProductToCart','addCart']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    isOutOfStockBusiness(b2bItem) {
      if (this.item.IsOverSaleable) {
        return false;
      }
      return b2bItem.ConvertNum <= this.item.StockLevel ? false : true
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/addCart', item);
        this.found = true;
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
      this.$store.dispatch('cart/getCart');
    },
    getItemQuantity: function() {
      if (isUserAuthenticated()) {
        if (this.cartProductsList.Sales_Order_Lines) {
          for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
            if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id || this.b2bCase.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
              this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
              this.found = true;
            }
          }
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    incrementAddToCart: function(item, add, e) {
      if (add) {
        let quantity = this.num + 1;
        if (isUserAuthenticated()) {
          flyToElement(event.target, $('.cart-link'));
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.getItemQuantity();
          })
        } else {
          this.$store.dispatch('cart/addProductToLocalCart', item);
        }
      } else if (!add) {
        let quantity = this.num - 1;
        if (quantity < 1) {
          this.deleteItem(item)
        } else {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart')
              .then(() => {
                this.getItemQuantity();
              })
            });
          } else {
            item.quantity = quantity;
            this.$store.dispatch('cart/updateLocalCart', item)
            .then(() => {
              this.$store.dispatch('cart/fetchCartProducts')
            });
          }
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item, event])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      flyToElement(payload.event.target, $('.cart-link'));
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    b2bAddToCart(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item, event])
        }
      }
      // if (isUserAuthenticated()) {
      //   flyToElement(event.target, $('.cart-link'));
      //  this.addCart(item)
      //   .then(() => {
      //     this.$store.dispatch('cart/getCart')
      //   });
      // }
    },
    handleAddToCartFail(product) {
      // alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
      alert(`Sorry, there are only ${Math.trunc(product.StockLevel ? product.StockLevel : 0)} available of ${product.Name}`);
    },
    goToProductDetail(product) {
      let id = product.UrlPath;
      this.updateActiveProduct(product.ProductNum);
      // this.$router.push({path: `productDetails/${id}` })
      this.$router.push({path: `productDetails/${id}`, params: {product: id }, name: 'productDetails' });
      // this.$router.history.push({path: `productDetails/${id}`, params: {product: id }, name: 'productDetails' });
      this.$router.go();
    },
    checkInsideCart() {
      if (isUserAuthenticated()) {
        if (!this.cartProductsList.Sales_Order_Lines || !this.cartProductsList.Sales_Order_Lines.length) {
          this.found = false;
          this.num = 0;
          return;
        }
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            return;
          }
        }
      } else {
        //For whatever reason this portion is necessary for removing the found variable when
        //itemCount is below 1.
        if (!this.cartProductsList.length) {
          this.found = false;
          this.num = 0;
          return;
        } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            }
          }
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
    determineInnerMaster() {
      let masterFound = false;
      let innerFound = false;
      let stock = this.item.StockLevel;
      let master = {};
      let inner = {};

      if (this.item.MasterInner) {
        this.item.MasterInner.map(item => {
          let itemStock = stock/item.ConvertNum;
          // save master and innr info if both out of stock
          if (item.ProductNum.charAt(this.item.MasterInner[0].ProductNum.length - 1) === "0") {
            master = item;
          }
          if (item.ProductNum.charAt(this.item.MasterInner[0].ProductNum.length - 1) === "2") {
            inner = item;
          }
          if (item.ProductNum.charAt(this.item.MasterInner[0].ProductNum.length - 1) === "0" && !masterFound && itemStock>=1) {
            this.b2bCase = item;
            this.b2bCase.StockLevel = itemStock;
            let master = this.b2bCase;
            masterFound = true;
          }
          if (item.ProductNum.charAt(this.item.MasterInner[0].ProductNum.length - 1) === "2" && !innerFound && !masterFound && itemStock>=1) {
            this.b2bCase = item;
            this.b2bCase.StockLevel = itemStock;
            innerFound = true;
          }
        });
        // if both out of stock, show master info
        if (masterFound === false && innerFound === false) {
          this.b2bCase = master;
          this.container = "master";
          if (Object.keys(master).length === 0) {
            this.b2bCase = inner;
            this.container = "inner";
          }
        }
        if (masterFound) {
          this.container = "master";
        } else {
          this.container = "inner";
        }
      }
    },
  },
  mounted() {
    this.checkInsideCart();
    this.getItemQuantity(this.item);
    this.determineInnerMaster();
  },
  beforeUpdate() {
    this.checkInsideCart();
    this.getItemQuantity(this.item);
    this.determineInnerMaster();
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    itemCount: state => state.cart.itemCount,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    windowHeight: state => state.navbar.windowHeight,
    windowWidth: state => state.navbar.windowWidth,
    business: state => state.auth.userDetails.IsBusiness,
    b2bCost() {
      if (this.b2bCase) {
        return this.b2bCase.ConvertNum ? (this.b2bCase.Price / this.b2bCase.ConvertNum.toFixed(2)).toFixed(2) : '';
      }
    },
  }),
  watch: {
    cartProductsList: function(newVal, oldVal) {
      if (newVal !== oldVal || newVal.length !== oldVal.length) {
        this.checkInsideCart();
        this.getItemQuantity(this.item);
      }
    },
  }
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productCard.less";
.v-lazy-image {
  filter: blur(5px);
  transition: filter 1.6s;
  will-change: filter;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
</style>



// WEBPACK FOOTER //
// src/view/productCard.vue